module.exports = __webpack_public_path__ + "media/images/iconPlus__errorRed-0a880361e9d80951346d816309ef3fe3.png";